<template>
  <div
    :class="{
      'flex gap-3 border-t border-solid border-[#EDF0F0] pb-4 pt-4 last:pb-0 md:gap-5': true,
    }"
  >
    <span
      :class="{
        'w-20 shrink-0 font-ptc-Rajdhani text-15px font-bold tracking-[0.3px] text-www-color-accent md:w-[118px]': true,
      }"
    >
      {{ timeOrDate }}
    </span>
    <div :class="{ 'flex flex-col gap-[2px]': true }">
      <span
        :class="{
          'text-[16px] font-bold leading-5 text-[#21303A]': true,
        }"
      >
        {{ name }}
      </span>
      <span
        :class="{
          'text-sm font-medium text-[#617480]': true,
        }"
      >
        {{ description }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ScheduleSection } from '~/sanity/types';
defineProps<ScheduleSection>();
</script>

<style></style>
